import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import NoDataMsg from 'library/noData';


const Body = ({ baseStore, compareTo, branches }) => {
    const baseStoreBranch = baseStore && baseStore[0] ? baseStore[0].baseStore : 0;
    const columns = () => {
        const columsArray = [];
        columsArray.push(<th>SKU</th>)
        columsArray.push(<th>Brand Name</th>)
        columsArray.push(<th>Product Name</th>)
        columsArray.push(<th>Product Rank #</th>)
        columsArray.push(<th>Quantity Sold</th>)

        compareTo.map((item, index) => {
            columsArray.push(<th>Quantity Sold</th>)
        })
        columsArray.push(<th>Total Quantity Sold</th>)
        return columsArray;
    }

    const body = () => {
        const bodyArray = [];
        baseStore.map((item, indexBS) => {
            let totalSold = item.sumQuantity;
            const row = (
                <tr>
                    <td>{item.sku}</td>
                    <td>{item.brand}</td>
                    <td>{item.productName}</td>
                    <td className="m-0 list_header text-center">{item.ranking}</td>
                    <td className="m-0 list_header text-center">{item.sumQuantity}</td>
                    {
                        compareTo.map(element => {
                            totalSold += element.productRankingComparingList[indexBS].compareQuantity;
                            let quantity = element.productRankingComparingList[indexBS].compareQuantity;
                            return <td className="text-center">{quantity == 0 ? "N/A" : quantity}</td>
                        })
                    }
                    <td className="text-center">{totalSold}</td>
                </tr>
            )
            bodyArray.push(row);
        })
        return bodyArray;
    }
    return (
        <React.Fragment>
            {
                baseStore.length <= 0 ?
                    //If there's NO DATA to display
                    <NoDataMsg />
                    :
                    //If there's DATA
                    <div>
                        <div>
                            <div className="row m-0 list_header text-center">
                                {/* {beginDate ?
                                    <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                        {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                    : moment().format('MMMM D, YYYY')} */}
                            </div>
                        </div>

                        <div className="pl-2 pr-2">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th colSpan="3"></th>
                                        <th colSpan="2" className="m-0 list_header text-center">{branches.find(e => { return e.value == baseStoreBranch }).text + " \n (Base store)"}</th>
                                        {
                                            compareTo.map((item, index) => {
                                                return <th className="m-0 list_header text-center">{branches.find(e => { return e.value == item.branchId }).text}</th>
                                            })
                                        }
                                        <th></th>
                                    </tr>
                                    <tr>
                                        {
                                            columns().map(item => {
                                                return item;
                                            })
                                        }
                                    </tr>

                                </thead>
                                <tbody>
                                    {
                                        body().map(item => {
                                            return item;
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
            }
        </React.Fragment>
    );
};

export default Body;